import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';

const API_KEY = import.meta.env.VITE_GOOGLE_TRANSLATE_API_KEY;
const BASE_URL = 'https://translation.googleapis.com/language/translate/v2';

export const translationService = {
  async translateText(text: string, targetLanguage: string): Promise<string> {
    try {
      if (!text) return '';
      
      // If target language is French (source language), return original text
      if (targetLanguage === 'fr') return text;

      // If no API key, return original text and log warning
      if (!API_KEY) {
        console.warn('Translation API key not found, returning original text');
        return text;
      }

      const response = await fetch(`${BASE_URL}?key=${API_KEY}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          q: text,
          target: targetLanguage,
          source: 'fr',
          format: 'text'
        }),
      });

      if (!response.ok) {
        throw new Error(`Translation failed with status: ${response.status}`);
      }

      const data = await response.json();
      return data.data.translations[0].translatedText;
    } catch (error) {
      console.error('Translation error:', error);
      // Return original text on error
      return text;
    }
  },

  async translatePost(postId: string, title: string, content: string) {
    try {
      const translations = {};
      const languages = ['fr', 'en', 'it'];
      
      await Promise.all(
        languages.map(async (lang) => {
          translations[lang] = {
            title: await this.translateText(title, lang),
            content: await this.translateText(content, lang)
          };
        })
      );

      const postRef = doc(db, 'forum_posts', postId);
      await updateDoc(postRef, { translations });

      return translations;
    } catch (error) {
      console.error('Error translating post:', error);
      throw error;
    }
  }
};